var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C22.1435 15 20.363 15.7375 19.0503 17.0503C17.7375 18.363 17 20.1435 17 22C17 24.862 18.782 27.623 20.738 29.762C21.7381 30.8517 22.8294 31.854 24 32.758C24.1747 32.624 24.3797 32.4607 24.615 32.268C25.5548 31.4963 26.4393 30.6596 27.262 29.764C29.218 27.623 31 24.863 31 22C31 20.1435 30.2625 18.363 28.9497 17.0503C27.637 15.7375 25.8565 15 24 15ZM24 35.214L23.433 34.824L23.43 34.822L23.424 34.817L23.404 34.803L23.329 34.75L23.059 34.553C21.6909 33.5248 20.4199 32.3733 19.262 31.113C17.218 28.875 15 25.636 15 21.999C15 19.6121 15.9482 17.3229 17.636 15.6351C19.3239 13.9472 21.6131 12.999 24 12.999C26.3869 12.999 28.6761 13.9472 30.364 15.6351C32.0518 17.3229 33 19.6121 33 21.999C33 25.636 30.782 28.876 28.738 31.111C27.5804 32.3713 26.3098 33.5228 24.942 34.551C24.8281 34.6361 24.713 34.7198 24.597 34.802L24.576 34.816L24.57 34.821L24.568 34.822L24 35.214ZM24 20C23.4696 20 22.9609 20.2107 22.5858 20.5858C22.2107 20.9609 22 21.4696 22 22C22 22.5305 22.2107 23.0392 22.5858 23.4142C22.9609 23.7893 23.4696 24 24 24C24.5304 24 25.0391 23.7893 25.4142 23.4142C25.7893 23.0392 26 22.5305 26 22C26 21.4696 25.7893 20.9609 25.4142 20.5858C25.0391 20.2107 24.5304 20 24 20ZM20 22C20 20.9392 20.4214 19.9217 21.1716 19.1716C21.9217 18.4215 22.9391 18 24 18C25.0609 18 26.0783 18.4215 26.8284 19.1716C27.5786 19.9217 28 20.9392 28 22C28 23.0609 27.5786 24.0783 26.8284 24.8285C26.0783 25.5786 25.0609 26 24 26C22.9391 26 21.9217 25.5786 21.1716 24.8285C20.4214 24.0783 20 23.0609 20 22Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.977dffeb26b4a44bc9e687a55a43c968.svg";
export { ForwardRef as ReactComponent };